//#region src/core/i18n/text/status.ts
const prefix = "status.";
const captionsOnText = {
	key: `${prefix}captionsOn`,
	text: "Captions on"
};
const captionsOffText = {
	key: `${prefix}captionsOff`,
	text: "Captions off"
};
const pausedText = {
	key: `${prefix}paused`,
	text: "Paused"
};
const playingText = {
	key: `${prefix}playing`,
	text: "Playing"
};
const fullscreenText = {
	key: `${prefix}fullscreen`,
	text: "Fullscreen"
};
const pipText = {
	key: `${prefix}pip`,
	text: "Picture in picture"
};
const exitPipText = {
	key: `${prefix}exitPip`,
	text: "Exit picture in picture"
};
const seekedToText = {
	key: `${prefix}seekedTo`,
	text: "Seeked to {time}"
};
//#endregion
export { captionsOffText, captionsOnText, exitPipText, fullscreenText, pausedText, pipText, playingText, seekedToText };

//# sourceMappingURL=status.js.map